module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', [_c('div', {
    staticClass: "accordion-item accordionForm"
  }, [_c('a', {
    staticClass: "item-content item-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.rotateChevron($event)
      }
    }
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "form-group row justify-content-start styleGeneral"
  }, [_c('div', {
    staticClass: "item-title createInvoiceBand col-sm-auto"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('common.formsSubTitle.gnrl')) + "\n                "), _c('i', {
    staticClass: "f7-icons formChevron"
  }, [_vm._v("chevron_right")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-item-content"
  }, [_c('div', {
    staticClass: "form-group d-flex justify-content-between"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v(_vm._s(_vm.$t('settings.rcvd_mod_loan_req')))]), _vm._v(" "), _c('label', {
    staticClass: "label-switch",
    class: _vm.sliderColorClass
  }, [_c('input', {
    staticClass: "checkboxSendPaymentsRequestEmail",
    attrs: {
      "type": "checkbox",
      "disabled": _vm.canSwitchSendEmail()
    },
    domProps: {
      "checked": _vm.settings.sendPaymentRequestEmail === '1',
      "value": _vm.settings.sendPaymentRequestEmail
    },
    on: {
      "change": _vm.switchSendPaymentsRequestEmail
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group d-flex justify-content-between"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v(_vm._s(_vm.$t('settings.activate_OCR')))]), _vm._v(" "), _c('label', {
    staticClass: "label-switch",
    class: _vm.sliderColorClass
  }, [_c('input', {
    staticClass: "checkboxOcrActivation",
    attrs: {
      "type": "checkbox",
      "disabled": _vm.canSwitchOcrActivation()
    },
    domProps: {
      "checked": _vm.settings.ocrActivation === '1',
      "value": _vm.settings.ocrActivation
    },
    on: {
      "change": _vm.changeSwitchOcrActivation
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group d-flex justify-content-between"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v(_vm._s(_vm.$t('settings.gnrt_bnk_trnsfr_ordr')))]), _vm._v(" "), _c('label', {
    staticClass: "label-switch",
    class: _vm.sliderColorClass
  }, [_c('input', {
    staticClass: "checkboxOcrActivation",
    attrs: {
      "type": "checkbox",
      "disabled": _vm.canSwitchSendPain()
    },
    domProps: {
      "checked": _vm.settings.isToGenerateXML === '1',
      "value": _vm.settings.isToGenerateXML
    },
    on: {
      "change": _vm.changeSwitchIsToGenerateXML
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v(_vm._s(_vm.$t('settings.vldtn_amnt')))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v(_vm._s(_vm.settings.validationThreshold))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.validationThreshold),
      expression: "settings.validationThreshold"
    }],
    staticClass: "range-slider-streammind",
    class: _vm.sliderColorClass,
    attrs: {
      "type": "range",
      "min": "0",
      "max": "150000",
      "value": "0",
      "step": "500",
      "disabled": _vm.canSwitchValidationThreshold()
    },
    domProps: {
      "value": (_vm.settings.validationThreshold)
    },
    on: {
      "__r": function($event) {
        return _vm.$set(_vm.settings, "validationThreshold", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('ul', [_c('div', {
    staticClass: "accordion-item accordionForm"
  }, [_c('a', {
    staticClass: "item-content item-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.rotateChevron($event)
      }
    }
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "form-group row justify-content-start styleGeneral"
  }, [_c('div', {
    staticClass: "item-title createInvoiceBand col-sm-auto"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('common.formsSubTitle.pymnt_mthd')) + "\n                "), _c('i', {
    staticClass: "f7-icons formChevron"
  }, [_vm._v("chevron_right")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-item-content"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "form-group col-sm-auto"
  }, [_c('div', {
    staticClass: "custom-control custom-radio custom-control-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.paymentMethod),
      expression: "settings.paymentMethod"
    }],
    staticClass: "custom-control-input",
    attrs: {
      "id": "defaultInline1",
      "type": "radio",
      "name": "methodRadio",
      "value": "application",
      "disabled": _vm.canSwitchPaymentMethod()
    },
    domProps: {
      "checked": _vm._q(_vm.settings.paymentMethod, "application")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.settings, "paymentMethod", "application")
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "custom-control-label",
    attrs: {
      "for": "defaultInline1",
      "disabled": _vm.canSwitchPaymentMethod()
    }
  }, [_vm._v(_vm._s(_vm.$t('settings.crdt_trnsfr')))])]), _vm._v(" "), _c('div', {
    staticClass: "custom-control custom-radio custom-control-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.paymentMethod),
      expression: "settings.paymentMethod"
    }],
    staticClass: "custom-control-input",
    attrs: {
      "id": "defaultInline2",
      "type": "radio",
      "name": "methodRadio",
      "value": "bankCard",
      "disabled": _vm.canSwitchPaymentMethod()
    },
    domProps: {
      "checked": _vm._q(_vm.settings.paymentMethod, "bankCard")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.settings, "paymentMethod", "bankCard")
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "custom-control-label",
    attrs: {
      "for": "defaultInline2",
      "disabled": _vm.canSwitchPaymentMethod()
    }
  }, [_vm._v(_vm._s(_vm.$t('settings.bnk_crd')))])])])])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('ul', [_c('div', {
    staticClass: "accordion-item accordionForm"
  }, [_c('a', {
    staticClass: "item-content item-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.rotateChevron($event)
      }
    }
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "form-group row justify-content-start styleGeneral"
  }, [_c('div', {
    staticClass: "item-title createInvoiceBand col-sm-auto"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('common.formsSubTitle.pymnt_mthd')) + "\n                "), _c('i', {
    staticClass: "f7-icons formChevron"
  }, [_vm._v("chevron_right")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-item-content"
  }, [_c('div', {
    staticClass: "form-group d-flex justify-content-between"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v(_vm._s(_vm.$t('settings.enable_instllment_rules')))]), _vm._v(" "), _c('label', {
    staticClass: "label-switch",
    class: _vm.sliderColorClass
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.enableInstallmentRules),
      expression: "settings.enableInstallmentRules"
    }],
    staticClass: "checkboxSendPaymentsRequestEmail",
    attrs: {
      "type": "checkbox",
      "disabled": _vm.canSwitchEnableInstallmentRules()
    },
    domProps: {
      "checked": _vm.settings.enableInstallmentRules === '1',
      "checked": Array.isArray(_vm.settings.enableInstallmentRules) ? _vm._i(_vm.settings.enableInstallmentRules, null) > -1 : (_vm.settings.enableInstallmentRules)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.settings.enableInstallmentRules,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.settings, "enableInstallmentRules", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.settings, "enableInstallmentRules", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.settings, "enableInstallmentRules", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group d-flex justify-content-between"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v(_vm._s(_vm.$t('settings.ngttn_as_dflt')))]), _vm._v(" "), _c('label', {
    staticClass: "label-switch",
    class: _vm.sliderColorClass
  }, [_c('input', {
    staticClass: "checkboxSendPaymentsRequestEmail",
    attrs: {
      "type": "checkbox",
      "disabled": _vm.canSwitchDefaultNegociationAllowed()
    },
    domProps: {
      "checked": _vm.settings.defaultNegotiationAllowed === '1',
      "value": _vm.settings.defaultNegotiationAllowed
    },
    on: {
      "change": _vm.changeSwitchDefaultNegotiationAllowed
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group d-flex justify-content-between"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v(_vm._s(_vm.$t('settings.edit_installments')))]), _vm._v(" "), _c('label', {
    staticClass: "label-switch",
    class: _vm.sliderColorClass
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.defaultModificationInstallmentsAllowed),
      expression: "settings.defaultModificationInstallmentsAllowed"
    }],
    staticClass: "checkboxSendPaymentsRequestEmail",
    attrs: {
      "type": "checkbox",
      "disabled": _vm.canSwitchModifInstallments()
    },
    domProps: {
      "checked": _vm.settings.defaultModificationInstallmentsAllowed === '1',
      "checked": Array.isArray(_vm.settings.defaultModificationInstallmentsAllowed) ? _vm._i(_vm.settings.defaultModificationInstallmentsAllowed, null) > -1 : (_vm.settings.defaultModificationInstallmentsAllowed)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.settings.defaultModificationInstallmentsAllowed,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.settings, "defaultModificationInstallmentsAllowed", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.settings, "defaultModificationInstallmentsAllowed", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.settings, "defaultModificationInstallmentsAllowed", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  })])])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8e157a52", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8e157a52","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/settings/SettingsList/DirectDebitSettings.vue
// module id = 2482
// module chunks = 2